import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    // React state for generation count
    const [generationCount, setGenerationCount] = useState(() => {
        return parseInt(localStorage.getItem('bbgenerationCount') || '0', 10);
    });

    // Sync `generationCount` state with `localStorage` on mount
    useEffect(() => {
        const storedCount = parseInt(localStorage.getItem('bbgenerationCount') || '0', 10);
        setGenerationCount(storedCount);
    }, []);

    if (loading) {
        return <div>Loading...</div>; // Replace with your loading spinner/UI
    }

    // Redirect if unauthenticated and generation count exceeds the limit
    if (!isAuthenticated && generationCount >= 3) {
        return <Navigate to="/login" />;
    }

    // Render children, where the business logic for incrementing count resides
    return React.cloneElement(children, {
        incrementGenerationCount: () => {
            const newCount = generationCount + 1;
            localStorage.setItem('bbgenerationCount', newCount);
            setGenerationCount(newCount);
        },
    });
};

export default ProtectedRoute;
